import React, { useEffect, useState } from 'react'
import Bredcrum from '../../common/Bredcrum'

import blog_image from "../../../assets/images/testimonial-bg.jpg"
import { Link, useNavigate, useParams } from 'react-router-dom'
import { blog_data } from './blog_data'
import { axiosInstance, config } from '../config'
import CommentSection from './Comments/CommentSection'
import moment from 'moment'

const BlogDetails = () => {

    const [blogData, setBlogData] = useState([])
    const [Loading,setLoading] = useState(false);

    const Navigate = useNavigate()

    const { post_slug } = useParams()

    useEffect(() => {
        setLoading(true)

        axiosInstance.get(`get-posts/${post_slug}`)
            .then(res => {
                setBlogData(res?.data?.posts) 
            })
            .catch((err) => {console.log(err)
                Navigate(`${config.appUrl}blogs`)
            })
            .finally(() => {
                setLoading(false)
            })


    }, [post_slug])

    useEffect(() => {
        // Select all tables inside div elements
        const tables = document.querySelectorAll('.blog_content table');
        if (tables) {
            // Loop through each table and wrap it inside a new div with the 'table-responsive' class
            tables.forEach(table => {
                // Create a new div element
                const wrapperDiv = document.createElement('div');
                wrapperDiv.classList.add('table-responsive');
 
                // Insert the new div before the table
                table.parentNode.insertBefore(wrapperDiv, table);
 
                // Move the table inside the new div
                wrapperDiv.appendChild(table);
            });
        }
    }, [blogData])

    return (
        <div>
            <Bredcrum
                heading={blogData?.name}
                path={[
                    { name: 'Post Details', path: 'blogs' },
                    { name: blogData.name, path: blogData.slug },
                ]}
            />
            <section className='py-5'>
                <div className='auto-container py-md-5 px-md-5'>
                    <div className='px-md-5'>
                        <div style={{
                            backgroundImage: `linear-gradient(#0a090c78, #0a090c78), url("${blogData?.imageUrl}")`,
                            backgroundSize: 'cover',
                            height: '550px'
                        }}
                            className='d-flex align-items-end p-md-5 p-4'
                        >
                            <div>
                                <h4 className='display-6 fw-semibold text-white'>
                                    {blogData?.name}
                                </h4>

                                <div className='mt-4 d-md-flex'>
                                    <div className='text-white'>
                                        <i className='bi bi-calendar-date me-2'></i>
                                        {moment(blogData?.created_at).format("DD MMMM, YYYY")}
                                    </div>
                                    <div className='text-white ms-md-4 mt-md-0 mt-2'>
                                        <i className='bi bi-person-circle me-2'></i>
                                        By Admin
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className='blog_content mt-4'>
                            {post_slug?.includes('why-choose') ? (
                                <div>
                                    <p className="fs-5 mb-4 text-secondary">
                                        Choosing the right driving school can make all the difference. At Precision Driving School, we focus on building safe driving habits, confidence, and real-world driving skills—not just helping you pass your driving test.
                                    </p>

                                    <div className="row g-4 my-4">
                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3 bg-light d-flex align-items-start gap-3 h-100">
                                                <span className="fs-3">🚗</span>
                                                <div>
                                                    <h5 className="fw-bold mb-1 text-dark">Experienced DVSA-Approved Instructors</h5>
                                                    <p className="mb-0 text-muted small">Friendly, patient instructors providing professional driving lessons in Leicester.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3 bg-light d-flex align-items-start gap-3 h-100">
                                                <span className="fs-3">🕒</span>
                                                <div>
                                                    <h5 className="fw-bold mb-1 text-dark">Flexible Lesson Times</h5>
                                                    <p className="mb-0 text-muted small">Weekday, evening, and weekend lessons to suit your schedule.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3 bg-light d-flex align-items-start gap-3 h-100">
                                                <span className="fs-3">🚘</span>
                                                <div>
                                                    <h5 className="fw-bold mb-1 text-dark">Automatic & Manual Driving Lessons</h5>
                                                    <p className="mb-0 text-muted small">Choose the learning style that suits you best.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3 bg-light d-flex align-items-start gap-3 h-100">
                                                <span className="fs-3">📍</span>
                                                <div>
                                                    <h5 className="fw-bold mb-1 text-dark">Local Leicester Knowledge</h5>
                                                    <p className="mb-0 text-muted small">Learn on local roads and driving test routes with experienced instructors.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3 bg-light d-flex align-items-start gap-3 h-100">
                                                <span className="fs-3">💳</span>
                                                <div>
                                                    <h5 className="fw-bold mb-1 text-dark">Competitive Lesson Packages</h5>
                                                    <p className="mb-0 text-muted small">Flexible lesson packages and intensive driving courses at competitive prices.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="p-3 border rounded-3 bg-light d-flex align-items-start gap-3 h-100">
                                                <span className="fs-3">🏆</span>
                                                <div>
                                                    <h5 className="fw-bold mb-1 text-dark">High-Quality Driving Tuition</h5>
                                                    <p className="mb-0 text-muted small">Professional one-to-one lessons designed to help you become a safe and confident driver.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <p className="fs-6 fst-italic mt-4 text-green fw-semibold">
                                        Let Precision Driving make your driving experience smooth, safe, and successful.
                                    </p>
                                </div>
                            ) : (
                                <p dangerouslySetInnerHTML={{__html : blogData?.description}}></p>
                            )}
                        </div>

                        <div className='my-5 pb-5'>
                            <CommentSection post_id={blogData?.id}/>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default BlogDetails